import { dataLayerPush } from '@/utils/dataLayerPush'
import { offerSelectionEvent } from '@/utils/trackingEvents'

import { RoomSelectionSlice, SelectedRoom, SliceState } from './types'

export const createRoomSelectionSlice: SliceState<RoomSelectionSlice> = (set, get) => ({
	roomSelection: {
		selectedRooms: [],
		selectedRoomCodes: [],
	},
	setRoom: (selectedRoom: SelectedRoom) =>
		set(
			(state) => {
				const {
					roomSelection: { selectedRooms, selectedRoomCodes },
				} = state
				const roomOfferFound = state.roomSelection.selectedRooms.find(
					(r) => r.roomConfigId === selectedRoom.roomConfigId
				)

				if (roomOfferFound) {
					const newRooms = selectedRooms.map((r) => {
						if (r.roomConfigId === roomOfferFound.roomConfigId) {
							return { ...r, room: selectedRoom.room }
						}

						return r
					})

					const newSelectedRoomCodes = newRooms.map((r) => ({
						roomCode: r.room.roomTypeCode,
						roomConfigId: r.roomConfigId,
					}))

					const newState = {
						...state,
						roomSelection: {
							selectedRooms: newRooms,
							selectedRoomCodes: newSelectedRoomCodes,
						},
					}

					dataLayerPush(offerSelectionEvent(selectedRoom, newState))
					return newState
				}
				const newState = {
					...state,
					roomSelection: {
						selectedRooms: [...selectedRooms, selectedRoom],
						selectedRoomCodes: [
							...selectedRoomCodes,
							{
								roomCode: selectedRoom.room.roomTypeCode,
								roomConfigId: selectedRoom.roomConfigId,
							},
						],
					},
				}

				dataLayerPush(offerSelectionEvent(selectedRoom, newState))
				return newState
			},
			false,
			'setRoomOffer'
		),
	removeRoom: (configId: string) =>
		set(
			(state) => ({
				...state,
				roomSelection: {
					...state.roomSelection,
					selectedRooms: state.roomSelection.selectedRooms.filter(
						(sr) => sr.roomConfigId !== configId
					),
					selectedRoomCodes: state.roomSelection.selectedRoomCodes.filter(
						(sr) => sr.roomConfigId !== configId
					),
				},
			}),
			false,
			'removeRoom'
		),
	removeAllRooms: () =>
		set(
			(state) => ({
				...state,
				roomSelection: {
					...state.roomSelection,
					selectedRooms: [],
					selectedRoomCodes: [],
				},
			}),
			false,
			'removeAllRooms'
		),
	getOtherSelectedRoomCodes: (roomConfigId: string) => {
		return get()
			.roomSelection.selectedRoomCodes.filter((code) => code.roomConfigId !== roomConfigId)
			.map((code) => code.roomCode)
	},
})
